<template>
  <div>
    <div class="box mb20">
      <el-page-header
        @back="$router.go(-1)"
      ></el-page-header>
    </div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20 flexBC" type="flex" align="middle">
        <div>
          <el-button @click="get_list" type="primary">{{
            $t("search_zh")
          }}</el-button>
          <el-button @click="reset" type="info">{{
            $t("btnTip.reset")
          }}</el-button>
        </div>
        <div>
        <el-button @click="toPage('toNotice')" type="success">{{
            $t("readList.toNotice")
          }}</el-button>
          <el-button @click="toPage('toTask')" type="success">{{
            $t("readList.toTask")
          }}</el-button>
          <el-button @click="toPage('toTopic')" type="success">{{
            $t("readList.toTopic")
          }}</el-button>
        </div>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <el-button type="primary" @click="handleClick('add')">{{
          $t("btnTip.add")
        }}</el-button>
        <el-button type="primary" @click="outExe">{{ $t("outExe") }}</el-button>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:operation="slotProps">
           <el-tooltip class="item" effect="dark" :content="$t('btnTip').edit" placement="top">
            <el-button
              @click="handleClick('edit',slotProps.callback.row)"
              icon="el-icon-edit-outline"
              type="primary"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              @click="del(slotProps.callback.row.id)"
              >{{ $t("btnTip").delete }}</el-button
            >
          </el-tooltip>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import { mixin_list } from "@/mixins";
import page from "@/components/page";
import myTable from "@/components/table";
import { readCommentList, deleteReadComment } from "@/api/api";
export default {
  name: "readCommentList",
  mixins: [mixin_list(readCommentList)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      filter: {
        search: "",
        club_id:this.$route.params.readId
      },
      columns: [
        {
          label: "ID",
          sortable: true,
          prop: "id",
          width: 80,
        },
        {
          label: this.$t("readCommentList.create_time"),
          sortable: true,
          prop: "create_time",
        },
        {
          label: this.$t("readCommentList.title"),
          sortable: true,
          prop: "title",
        },
        {
          label: this.$t("readCommentList.content"),
          sortable: true,
          prop: "content"
        },
        {
          label: this.$t("readCommentList.commentator"),
          sortable: true,
          prop: "commentator",
        },
        {
          label: this.$t("operation"),
          prop: "",
          width: 300,
          slot: "operation",
        },
      ],
    }
  },
  methods: {
    toPage(toPage){
      switch(toPage){
        case 'toTask':
          this.$router.replace(`/readManagement/readList/${this.$route.params.readId}/readTaskList`)
          return
        case 'toTopic':
          this.$router.replace(`/readManagement/readList/${this.$route.params.readId}/readTopicList`)
          return
        case 'toNotice':
          this.$router.replace(`/readManagement/readList/${this.$route.params.readId}/readNoticeList`)
          return
        case 'toComment':
          this.$router.replace(`/readManagement/readList/${this.$route.params.readId}/readCommentList`)
          return
      }
    },
    async handleClick(type, data) {
      switch (type) {
        case "add":
          this.$router.push(`/readManagement/readList/${this.$route.params.readId}/readCommentList/edit`)
          break;
        case "edit":
          this.$router.push(`/readManagement/readList/${this.$route.params.readId}/readCommentList/edit?id=${data.id}`)
          break;
      }
    },
    async del(id) {
      this.$confirm(this.$t('sureDelete'), this.$t('tips'), {
        confirmButtonText: this.$t('btnTips').submit,
        cancelButtonText: this.$t('btnTips').cancel,
        type: 'warning'
      }).then(async () => {
        let res = await deleteReadComment(id)
        this.get_list()
      }).catch({
      })
    },
  },
};
</script>
<style lang="scss" scoped>

</style>